import React, { useRef } from "react";
import Slider from "react-slick";
// import WOW from "wow.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSection = () => {
  const sliderRef = useRef(null);

  // useEffect(() => {
  //   // Initialize WOW.js for animations
  //   new WOW().init();
  // }, []);

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 786,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const testimonials = [
    {
      name: "Alessandro Daluz",
      image: "https://res.cloudinary.com/dlj1daxbn/image/upload/v1740926875/s5gadrgmtvsojpfvpryz.jpg?w=200&h=200&fit=crop",
      quote: "Great service! Highly recommended for fast, secure, and efficient shipping worldwide with excellent support.",
    },
    {
      name: "John Doe",
      image: "https://images.unsplash.com/photo-1531561855568-3036cd4f03ba?w=200&h=200&fit=crop",
      quote: "Amazing experience! Packages always arrive on time, handled professionally, and tracking is super reliable.",
    },
    {
      name: "Jane Smith",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop",
      quote: "Really impressed with the support team! They handled my urgent shipment smoothly and professionally.",
    },
    {
      name: "Michael Johnson",
      image: "https://sea2.discourse-cdn.com/flex020/user_avatar/community.elfsight.com/helga/288/1155_2.png?w=200&h=200&fit=crop",
      quote: "The best logistics company! Their real-time tracking and efficient deliveries make them truly exceptional.",
    },
    {
      name: "Emily Davis",
      image: "https://images.unsplash.com/photo-1554151228-14d9def656e4?w=200&h=200&fit=crop",
      quote: "Reliable and professional logistics service! They ensure my shipments arrive on time without issues.",
    },
    {
      name: "Robert Wilson",
      image: "https://sea2.discourse-cdn.com/flex020/user_avatar/community.elfsight.com/annas/288/6001_2.png?w=200&h=200&fit=crop",
      quote: "Outstanding shipping solutions! Secure, fast, and the customer support team is always very responsive.",
    },
    {
      name: "Sophia Martinez",
      image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=200&h=200&fit=crop",
      quote: "Top-notch logistics! They make global shipping effortless with their outstanding customer service team.",
    },
    {
      name: "William Brown",
      image: "https://images.unsplash.com/photo-1566753323558-f4e0952af115?w=200&h=200&fit=crop",
      quote: "Highly efficient shipping! They handle fragile items with great care and ensure timely delivery.",
    },
    {
      name: "Olivia Taylor",
      image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=200&h=200&fit=crop",
      quote: "Their logistics team is professional, ensuring safe, secure, and quick delivery of all shipments.",
    },
    {
      name: "James Anderson",
      image: "https://res.cloudinary.com/dlj1daxbn/image/upload/v1737567444/y89tokehdxiezjvrbkkv.jpg?w=200&h=200&fit=crop",
      quote: "Exceptional service! Their expertise in handling international freight has simplified my business needs.",
    }
];





  return (
    <section className="testimonial-section padding" style={{ backgroundColor: "#f0f8ff" }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-1" />
          <div className="col-md-3 wow fade-in-right" data-wow-delay="0.3s">
            <div className="titlediv">
              <span>See who is walking this path with us</span>
              <h3 className="text-anim" data-effect="fade-in-right" data-delay="0.3" data-duration={1}>
                Clients Reviews
              </h3>
              <img src="./images/divider.png" alt="Divider" className="fade-in-bottom" data-wow-delay="0.5s" />
              <p>Watch the video and understand why thousands of people are already using our services and are protected.</p>
              <div className="Navigationbuttons d-flex gap-3">
                <div className="lefticon prev-btn wow fade-in-bottom" data-wow-delay="0.6s" onClick={() => sliderRef.current.slickPrev()}>
                  <i className="fa-solid fa-chevron-left" style={{ fontSize: 24 }} />
                </div>
                <div className="lefticon next-btn wow fade-in-bottom" data-wow-delay="0.7s" onClick={() => sliderRef.current.slickNext()}>
                  <i className="fa-solid fa-chevron-right" style={{ fontSize: 24 }} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <Slider ref={sliderRef} {...settings} className="testimonial-slider">
              {testimonials.map((testimonial, index) => (
                <div className="p-2" key={index}>
                  <img className="quoate" src="./images/quoates.svg" alt="Quote" />
                  <div className="Reviewbox p-2">
                    <div className="d-flex mt-4 align-items-center">
                      <img src={testimonial.image} className="imagereview" alt={testimonial.name} />
                      <div><b>{testimonial.name}</b></div>
                    </div>
                    <p className="mt-2">"{testimonial.quote}"</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};


export default TestimonialSection;

